module.exports = __webpack_public_path__ + "static/assets/0ecb87cc3390cba417aea1aa33cf5c65.png";